import React, { Component } from 'react';
import './Form.css';
import Message from '../Message/Message';
import MyChat from '../Message/MyChat.js';
import firebase from 'firebase';
export default class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: 'Rotimi',
      message: '',
      list: [],
      videoTitles:this.props.videoTitle,
      title:''
    };
   // this.props.firebase.freeVideo().orderByChild('username')this.props.firebase.freeVideo().orderByChild('username').equalTo(this.state.username)
    this.messageRef = firebase.database().ref().child('front-mediaPay').orderByChild('title').equalTo(this.props.message.title);
    this.messageReff = firebase.database().ref().child('chat');
    this.listenMessages();
  }
 
  componentWillReceiveProps(nextProps) {
    if(nextProps.user) {
      this.setState({'userName': nextProps.user.displayName});
    }
    if(nextProps.videoTitle) {
      this.setState({'videoTitle': nextProps.videoTitle});
    }
  }
  handleChange(event) {
    this.setState({message: event.target.value});
  }
  
//ListMessage

listenMessages(){
  this.messageReff
      .on('value', message => {
       // console.log(message.val())
        this.setState({
          list: Object.values(message.val())
        })
      });
      
}
componentDidMount(){

 //this.listenMessages();
}
  
  handleKeyPress(event) {
    if (event.key !== 'Enter') return;
    this.handleSend();
  }
  handleSend=() =>{
    if (this.state.message) {
      var newItem = {
        userName: this.state.userName,
        message: this.state.message,
      }
      this.messageReff.push(newItem);
      this.setState({ message: '' });
    }
  }
 
  render() {
   //console.log(this.state.list);
   //console.log(this.props.message.title);
    return (
      <div className="form">
        <div className="form__message">   
       
      <Message  message={this.props.message.messages} user={this.state.userName}  />
      
        </div>
        <div className="form__message">   
        { this.state.list.map((item, index) =>
      <MyChat key={index} message={item} />
        )}
        </div>
                  <div class="ui input focus">
  <input type="text" 
  placeholder="Type message"
            value={this.state.message}
            onChange={this.handleChange.bind(this)}
            onKeyPress={this.handleKeyPress.bind(this)}/>
</div> <br/>

          <button
            className="form__button"
            onClick={this.handleSend}
          >
            send
          </button>
        </div>
      
    );
  }
}